import { render } from "./ApplicationsMgt.vue?vue&type=template&id=30096abc&scoped=true"
import script from "./ApplicationsMgt.vue?vue&type=script&lang=js"
export * from "./ApplicationsMgt.vue?vue&type=script&lang=js"

import "./ApplicationsMgt.vue?vue&type=style&index=0&id=30096abc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30096abc"]])

export default __exports__